import { takeLatest, put, call } from 'redux-saga/effects';
import { history } from '@commons';
import { createBaixaManualEstoqueProducao, updateBaixaManualEstoqueProducao } from '../service';
import {
  CREATE_BAIXAR_MANUAL_ESTOQUE_PRODUCAO,
  CREATE_BAIXAR_MANUAL_ESTOQUE_PRODUCAO_PENDING,
  CREATE_BAIXAR_MANUAL_ESTOQUE_PRODUCAO_SUCCESS,
  CREATE_BAIXAR_MANUAL_ESTOQUE_PRODUCAO_FAILURE,
  CONFIG_SESSION
} from '@handler';
import { storage } from '@commons/storage';
import { AlertSuccess, AlertError } from '@components/common/AlertToast';
import { trackingEventCX, MODULE_ACTIONS_ENUM } from '@handler/tracking/customerX';

function* sagaCreateBaixaManualEstoqueProducao(action) {
  yield put({ type: CREATE_BAIXAR_MANUAL_ESTOQUE_PRODUCAO_PENDING });

  try {
    if (action.data.id === undefined || action.data.id === null) {
      yield call(createBaixaManualEstoqueProducao, {
        ...action.data,
        propriedade: {
          id: JSON.parse(storage.get(CONFIG_SESSION)).fazendaSelecionada.id
        },
        safra: {
          id: JSON.parse(storage.get(CONFIG_SESSION)).safraAtiva.id
        }
      });
      trackingEventCX('action', MODULE_ACTIONS_ENUM.BAIXA_MANUAL_ESTOQUE_AGRICOLA_CRIAR);
    } else {
      yield call(updateBaixaManualEstoqueProducao,
        {
          ...action.data,
          id: action.data.id
        }
      );
      trackingEventCX('action', MODULE_ACTIONS_ENUM.BAIXA_MANUAL_ESTOQUE_AGRICOLA_EDITAR);
    }

    yield put({ type: CREATE_BAIXAR_MANUAL_ESTOQUE_PRODUCAO_SUCCESS, registro: action.data });
    history.push('/agricultura/producao/baixaManual');
    AlertSuccess('Registro salvo com sucesso!');
  } catch (error) {
    yield put({ type: CREATE_BAIXAR_MANUAL_ESTOQUE_PRODUCAO_FAILURE, registro: action.data });
    AlertError('Falha ao baixar estoque! Tente novamente...');
  }
}

export default function* watchCreateBaixaManualEstoqueProducao() {
  yield takeLatest(CREATE_BAIXAR_MANUAL_ESTOQUE_PRODUCAO, sagaCreateBaixaManualEstoqueProducao);
}
